export type ErrorDetail = Record<string, unknown> | null;

export const normaliseErrorDetail = (detail: unknown): ErrorDetail => {
  if (!detail) {
    return null;
  }
  if (typeof detail === "string") {
    return { message: detail };
  }
  if (typeof detail !== "object" || Array.isArray(detail)) {
    return null;
  }
  return detail as Record<string, unknown>;
};

export const formatDetailLabel = (key: string): string =>
  key
    .replace(/([A-Z])/g, " $1")
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase())
    .trim();

export const getDetailEntries = (detail: ErrorDetail) =>
  detail
    ? Object.entries(detail).filter(
        ([key, value]) => key !== "message" && value !== undefined && value !== null
      )
    : [];
